import React, { useEffect, useCallback } from 'react';
import * as slice from "../../store/quiz/quizSlice";
import * as timerSlice from '../../store/quiz/timerSlice';
import { useAppDispatch, useAppSelector } from "../../store/hook";
import { quizActions } from '../../store/quiz/quizSlice';
import { quizTimerActions } from '../../store/quiz/timerSlice';

export const useQuiz = () => {
    const dispatch = useAppDispatch();
    return {
        setScreen: useCallback((payload) => {
            dispatch(quizActions.setCurrentScreen(payload));
        }, [dispatch]),
        setResult: useCallback((payload) => {
            dispatch(quizActions.setResult(payload));
        }, [dispatch]),
        setCurrentQuestionGroup: useCallback((payload) => {
            dispatch(quizActions.setQuestionGroup(payload));
        }, [dispatch]),
        setGroupQuestionCount: useCallback((payload) => {
            dispatch(quizActions.setGroupQuestionCount(payload));
        }, [dispatch]),
        setQuestions: useCallback((payload) => {
            dispatch(quizActions.setQuestions(payload));
        }, [dispatch]),
        setType: useCallback((payload) => {
            dispatch(quizActions.setType(payload));
        }, [dispatch]),
        
        setQuizDetails: useCallback((payload) => {
            dispatch(quizActions.setQuizDetails(payload));
        }, [dispatch]),
        setQuizTopic: useCallback((payload) => {
            dispatch(quizActions.setQuizTopic(payload));
        }, [dispatch]),
        setGradingResult: useCallback((payload) => {
            dispatch(quizActions.setGradingResult(payload));
        }, [dispatch]),
        setCourseAssigned: useCallback((payload) => {
            dispatch(quizActions.setCourseAssigned(payload));
        }, [dispatch]),
        setNextCourseId: useCallback((payload) => {
            dispatch(quizActions.setNextCourseId(payload));
        }, [dispatch]),
        setSpeechEvaluationScore: useCallback((payload) => {
            dispatch(quizActions.setSpeechEvaluationScore(payload));
        }, [dispatch]),
        setOverallPercentage: useCallback((payload) => {
            dispatch(quizActions.setOverallPercentage(payload));
        }, [dispatch]),
        setCurrentSpeechSentance: useCallback((payload) => {
            dispatch(quizActions.setCurrentSpeechSentance(payload));
        }, [dispatch]),
        setCurrentQuestionNumber: useCallback((payload) => {
            dispatch(quizActions.setCurrentQuestion(payload));
        }, [dispatch]),
        setSelectedDiagnosticTestMapping: useCallback((payload) => {
            dispatch(quizActions.setSelectedDiagnosticTestMapping(payload));
        }, [dispatch]),
        setEvaluationId: useCallback((payload) => {
            dispatch(quizActions.setEvaluationId(payload));
        }, [dispatch]),
        setCurrentCourseDetails: useCallback((payload) => {
            dispatch(quizActions.setCurrentCourseDetails(payload));
        }, [dispatch]),
        updateCurrentCourseDetails: useCallback((payload) => {
            dispatch(quizActions.updateCurrentCourseDetails(payload));
        }, [dispatch]),
        setEvaluationResult: useCallback((payload) => {
            dispatch(quizActions.setEvaluationResult(payload));
        }, [dispatch]),

        quizDetails: useAppSelector(slice.getQuizDetail),
        current: useAppSelector(slice.getCurrent),
        questions: useAppSelector(slice.getQuestions),
        result: useAppSelector(slice.getResult),
        currentQuestionGroup: useAppSelector(slice.getCurrentQuestionGroup),
        groupQuestionCount: useAppSelector(slice.getGroupQuestionCount),
        questionGroup: useAppSelector(slice.getQuestionGroup),
        questionGroups: useAppSelector(slice.getQuestionGroups),
        quizTopic: useAppSelector(slice.getQuizTopic),
        type: useAppSelector(slice.getType),
        gradingResult: useAppSelector(slice.getGradingResult),
        courseAssigned: useAppSelector(slice.courseAssigned),
        nextCourseId: useAppSelector(slice.nextCourseId),
        speechEvaluationScore: useAppSelector(slice.speechEvaluationScore),
        overallPercentage: useAppSelector(slice.getOverallPercentage),
        currentSpeechSentance: useAppSelector(slice.currentSpeechSentance),
        currentQuestionNumber: useAppSelector(slice.currentQuestion),
        selectedDiagnosticTestMapping: useAppSelector(slice.selectedDiagnosticTestMapping),
        evaluationId: useAppSelector(slice.evaluationId),
        currentCourseDetails: useAppSelector(slice.currentCourseDetails),
        evaluationResult: useAppSelector(slice.evaluationResult),
    };
};

export const useQuizTimer = () => {
    const dispatch = useAppDispatch();
    return {
        setShowTimerModal: useCallback((payload) => {
            dispatch(quizTimerActions.setShowTimerModal(payload));
        }, [dispatch]),
        setTimer: useCallback((payload) => {
            dispatch(quizTimerActions.setTimer(payload));
        }, [dispatch]),
        setEndTime: useCallback((payload) => {
            dispatch(quizTimerActions.setEndTime(payload));
        }, [dispatch]),
        setShowResultModal: useCallback((payload) => {
            dispatch(quizTimerActions.setShowResultModal(payload));
        }, [dispatch]),
        setTimerStarted: useCallback((payload) => {
            dispatch(quizTimerActions.setTimerStarted(payload))
        }, [dispatch]),

        timer: useAppSelector(timerSlice.getTimer),
        timerStarted: useAppSelector(timerSlice.getTimerStarted),
        endTime: useAppSelector(timerSlice.getEndTime),
        endedAt: useAppSelector(timerSlice.getEndedAt),
        showResult: useAppSelector(timerSlice.getShowResult),
        showTimerModal: useAppSelector(timerSlice.getShowTimerModal),
    }
}

export const useTimer = (timer, quizDetails, setEndTime, setTimer, setShowTimerModal, showResultModal, setTimerStarted) => {
    const ended = React.useRef(false);

    useEffect(() => {
        if (timer <= 0 && !ended.current) {
            const timeTaken = quizDetails.totalTime
            setEndTime(timeTaken)
            setShowTimerModal(true)
            setTimer(0)
            ended.current = true;
            setTimerStarted(false);
        }
    }, [timer, quizDetails.totalTime, setEndTime, setShowTimerModal, setTimer])

    useEffect(() => {
        if (!timer) return;

        if (!showResultModal) {
            setTimerStarted(true);
            const countTimer = setTimeout(() => {
                setTimer(timer - 1)
            }, 1000)
            return () => clearTimeout(countTimer)
        }
    }, [timer, setTimer])
}
